











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'
import {RelatorioGeracaoCollection} from '@/model/collection/RelatorioGeracaoCollection'
import {ListRelatorioGeracaoSchema} from '@/schema/resource/RelatorioGeracao/ListRelatorioGeracaoSchema'
import {CsvRelatorioGeracaoSchema} from '@/schema/resource/RelatorioGeracao/CsvRelatorioGeracaoSchema'

@Component
export default class ListRelatorioGeracaoView extends Mixins(MixinQueryRouter) {
  schema = new ListRelatorioGeracaoSchema()
  collection = new RelatorioGeracaoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: RelatorioGeracao) {
    Helper.pushByName('editRelatorioGeracao', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new RelatorioGeracaoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvRelatorioGeracao()
    new CsvRelatorioGeracaoSchema().downloadCsv(csv.all())
  }
}
